import { render, staticRenderFns } from "./issure.vue?vue&type=template&id=16ab42cc&scoped=true"
import script from "./issure.vue?vue&type=script&lang=js"
export * from "./issure.vue?vue&type=script&lang=js"
import style0 from "./issure.vue?vue&type=style&index=0&id=16ab42cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ab42cc",
  null
  
)

export default component.exports